var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatRepair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 1022.859-.512 3.449a10.5 10.5 0 0 0-1.965.814l-2.8-2.078-3.537 3.537 2.074 2.795a10.5 10.5 0 0 0-.815 1.973l-3.445.51v5l3.45.511a10.5 10.5 0 0 0 .814 1.965l-2.078 2.8 3.537 3.538 2.795-2.074a10.5 10.5 0 0 0 1.972.814l.51 3.446h5l.512-3.45a10.5 10.5 0 0 0 1.965-.814l2.8 2.078 3.537-3.537-2.074-2.795a10.5 10.5 0 0 0 .815-1.973l3.445-.51v-5l-3.45-.511a10.5 10.5 0 0 0-.814-1.965l2.078-2.8-3.537-3.538-2.795 2.074a10.5 10.5 0 0 0-1.972-.814l-.51-3.445h-5z",
    style: {
      opacity: 1,
      fill: "#0084ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none"
    },
    transform: "translate(0 -1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1031.46a5.5 5.5 0 0 0-3 4.898 5.5 5.5 0 0 0 5.5 5.5 5.5 5.5 0 0 0 5.5-5.5 5.5 5.5 0 0 0-3-4.892v4.893l-2.5 1.5-2.5-1.5v-4.899z",
    style: {
      opacity: 1,
      fill: "#ffaf00",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none"
    },
    transform: "translate(0 -1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1039.359v10.5h-5v-10.5",
    style: {
      opacity: 1,
      fill: "#ffaf00",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.99999994,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none"
    },
    transform: "translate(0 -1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1022.36a.5.5 0 0 0-.494.425l-.47 3.172c-.495.165-.975.363-1.44.596l-2.575-1.91a.5.5 0 0 0-.652.049l-3.537 3.537a.5.5 0 0 0-.049.65l1.908 2.572c-.232.467-.431.949-.595 1.444l-3.168.469a.5.5 0 0 0-.428.495v5a.5.5 0 0 0 .426.495l3.174.47c.164.493.363.973.595 1.438l-1.912 2.576a.5.5 0 0 0 .049.652l3.537 3.537a.5.5 0 0 0 .652.047l2.57-1.906c.468.233.95.431 1.446.596l.469 3.168a.5.5 0 0 0 .494.427h5a.5.5 0 0 0 .494-.427l.47-3.172c.495-.165.975-.363 1.44-.596l2.575 1.91a.5.5 0 0 0 .652-.047l3.537-3.537a.5.5 0 0 0 .049-.652l-1.908-2.572c.232-.467.431-.949.595-1.444l3.168-.469a.5.5 0 0 0 .428-.494v-5a.5.5 0 0 0-.426-.496l-3.174-.47a10.986 10.986 0 0 0-.595-1.438l1.912-2.576a.5.5 0 0 0-.049-.65l-3.537-3.538a.5.5 0 0 0-.652-.049l-2.57 1.907c-.468-.233-.95-.432-1.446-.596l-.469-3.168a.5.5 0 0 0-.494-.426h-5zm.432 1h4.136l.448 3.017a.5.5 0 0 0 .351.406c.651.194 1.28.454 1.88.776a.5.5 0 0 0 .534-.04l2.448-1.816 2.927 2.926-1.822 2.455a.5.5 0 0 0-.037.535 10 10 0 0 1 .775 1.871.5.5 0 0 0 .405.352l3.023.447v4.139l-3.018.445a.5.5 0 0 0-.406.352 9.998 9.998 0 0 1-.775 1.879.5.5 0 0 0 .037.535l1.818 2.449-2.927 2.926-2.454-1.82a.5.5 0 0 0-.535-.04 10.02 10.02 0 0 1-1.873.776.5.5 0 0 0-.35.406l-.449 3.023h-4.136l-.448-3.02a.5.5 0 0 0-.351-.405 10.002 10.002 0 0 1-1.88-.776.5.5 0 0 0-.534.04l-2.448 1.816-2.927-2.926 1.822-2.455a.5.5 0 0 0 .037-.535 10 10 0 0 1-.775-1.871.5.5 0 0 0-.405-.352L3 1038.428v-4.139l3.018-.445a.5.5 0 0 0 .406-.352c.194-.65.454-1.28.775-1.879a.5.5 0 0 0-.037-.535l-1.818-2.45 2.927-2.925 2.454 1.82a.5.5 0 0 0 .535.04 10.02 10.02 0 0 1 1.873-.776.5.5 0 0 0 .35-.406l.449-3.022z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(0 -1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.484 1030.96a.5.5 0 0 0-.21.056A6.003 6.003 0 0 0 10 1036.36c0 3.308 2.692 6 6 6s6-2.692 6-6a6 6 0 0 0-3.273-5.336.5.5 0 0 0-.727.443v4.61l-2 1.198-2-1.199v-4.615a.5.5 0 0 0-.516-.5zm-.484 1.618v3.781a.5.5 0 0 0 .242.428l2.5 1.5a.5.5 0 0 0 .516 0l2.5-1.5a.5.5 0 0 0 .242-.428v-3.775c1.17.936 1.998 2.24 2 3.775 0 2.768-2.233 5-5 5s-5-2.232-5-5c0-1.536.828-2.844 2-3.78z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(0 -1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.492 1040.852a.5.5 0 0 0-.492.507v8.5a.5.5 0 1 0 1 0v-8.5a.5.5 0 0 0-.508-.507zm5 0a.5.5 0 0 0-.492.507v8.5a.5.5 0 1 0 1 0v-8.5a.5.5 0 0 0-.508-.507z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.99999994,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.0999999,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(0 -1020.362)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatRepair);
export default __webpack_public_path__ + "static/media/stat_repair.8d0d5e4c76e56782cfce02b96927eb6f.svg";
export { ForwardRef as ReactComponent };